import React from 'react';
import PropTypes from 'prop-types';
import { handleClick } from '../Link';
import SimpleNotificationPopup from './SimpleNotificationPopup';
import EditDevicePopUp from './EditDevicePopUp';
import NewInstallationPopUp from './DevicePopups/NewInstallationPopUp';
import EditOwnershipPopup from './EditOwnershipPopup';
import ConfigurationPopup from './ConfigurationPopUp';
import HistoryListPopUp from '../HistoryListPopUp';
import SafeTechPopup from '../SafeTechPopup';
import SendCommandPopup from './SendCommandPopup';
import SafeFloorInstallation from './DevicePopups/SafeFloorInstallation';

class NotificationPopupCustomContent extends React.Component {
  handleClickAndClose = event => {
    handleClick(event);
    this.props.closePopup();
  };
  render() {
    const subtype = this.props.data.get('subtype');
    const options = this.props.data.get('options');
    const onClose = this.props.closePopup;
    let popupContent = {};
    switch (subtype) {
      case 'SHOW_HISTORY':
        return (
          <HistoryListPopUp
            onClose={onClose}
            deviceName={options.deviceName}
            serial={options.serial}
            deviceType={options.devicetype}
          />
        );
      case 'SAFETECH_ADD_PROFILE':
        return (
          <SafeTechPopup
            onClose={onClose}
            serial={options.serial}
            nextProfile={options.nextProfile}
          />
        );
      case 'SHOW_HISTORY2':
        popupContent = {
          title: 'history_title',
          message: 'history_msg',
          error: true,
        };
        return <SimpleNotificationPopup {...popupContent} onClose={onClose} />;

      case 'SHOW_CONFIGURATION_INFO':
        return (
          <ConfigurationPopup
            {...popupContent}
            onClose={onClose}
            bottle={options.bottle}
            valve={options.valve}
            medium={options.medium}
          />
        );
      case 'EDIT_DEVICE':
        popupContent = {
          error: true,
        };
        return (
          <EditDevicePopUp
            {...popupContent}
            onClose={onClose}
            serial={options.serial}
            comment={options.comment}
            address={options.address}
            devicetype={options.devicetype}
          />
        );
      case 'NEW_INSTALLATION':
        popupContent = {
          error: true,
        };
        return (
          <NewInstallationPopUp
            {...popupContent}
            onClose={onClose}
            serial={options.serial}
            devicetype={options.devicetype}
          />
        );
      case 'SAFEFLOOR_INSTALLATION':
        popupContent = {
          error: false,
        };
        return (
          <SafeFloorInstallation
            {...popupContent}
            onClose={onClose}
            serial={options.serial}
            devicetype={options.devicetype}
            connecteddevices={options.connecteddevices}
          />
        );

      case 'SEND_COMMAND':
        popupContent = {
          error: true,
        };
        return (
          <SendCommandPopup
            {...popupContent}
            onClose={onClose}
            serial={options.serial}
            devicetype={options.devicetype}
          />
        );
      case 'EDIT_INSTALLER':
        popupContent = {
          error: true,
        };
        return (
          <EditOwnershipPopup
            {...popupContent}
            onClose={onClose}
            serial={options.serial}
            devicetype={options.devicetype}
            userType={'installer'}
          />
        );

      case 'EDIT_ENDUSER':
        popupContent = {
          error: true,
        };
        return (
          <EditOwnershipPopup
            {...popupContent}
            onClose={onClose}
            serial={options.serial}
            devicetype={options.devicetype}
            userType={'viewer'}
          />
        );
      default:
        return null;
    }
  }
}

NotificationPopupCustomContent.propTypes = {
  data: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  closePopup: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};

export default NotificationPopupCustomContent;



// WEBPACK FOOTER //
// ./src/components/Popup/NotificationPopUpCustomContent.js